import { RealEstateType } from '../../@types/realEstateType'

export interface SpaceLimit {
  min: number
  max: number
}

type LivingSpaceLimits = {
  [RealEstateType.HOUSE]: SpaceLimit
  [RealEstateType.APARTMENT]: SpaceLimit
  [RealEstateType.COMMERCIAL]: SpaceLimit
}

export const livingSpaceLimits: LivingSpaceLimits = {
  [RealEstateType.HOUSE]: { min: 20, max: 1000 },
  [RealEstateType.APARTMENT]: { min: 10, max: 500 },
  [RealEstateType.COMMERCIAL]: { min: 50, max: 100000 },
}

type PlotAreaLimits = {
  [RealEstateType.HOUSE]: SpaceLimit
  [RealEstateType.LAND]: SpaceLimit
  [RealEstateType.COMMERCIAL]: SpaceLimit
}

export const plotAreaLimits: PlotAreaLimits = {
  [RealEstateType.HOUSE]: { min: 20, max: 5000 },
  [RealEstateType.LAND]: { min: 200, max: 5000 },
  [RealEstateType.COMMERCIAL]: { min: 500, max: 10000 },
}

export const validateLivingSpace = (realEstateType: RealEstateType, livingSpace?: number): boolean => {
  return (
    realEstateType !== RealEstateType.LAND &&
    typeof livingSpace !== 'undefined' &&
    livingSpace >= livingSpaceLimits[realEstateType].min &&
    livingSpace <= livingSpaceLimits[realEstateType].max
  )
}

export const validatePlotArea = (realEstateType: RealEstateType, plotArea?: number): boolean => {
  return (
    realEstateType !== RealEstateType.APARTMENT &&
    typeof plotArea !== 'undefined' &&
    plotArea >= plotAreaLimits[realEstateType].min &&
    plotArea <= plotAreaLimits[realEstateType].max
  )
}
